/**
 * Skeleton loading placeholder.
 * Renders a pulsing slate-200 block to indicate loading content.
 */
interface SkeletonProps {
  className?: string;
}

export default function Skeleton({ className = '' }: SkeletonProps) {
  return (
    <div
      className={`animate-pulse rounded bg-slate-200 ${className}`}
      aria-hidden="true"
    />
  );
}

/** Pre-composed skeleton for a card with title + 3 lines of text. */
export function CardSkeleton() {
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-6 space-y-4" role="status" aria-label="Loading">
      <Skeleton className="h-5 w-1/3" />
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-5/6" />
      <Skeleton className="h-4 w-2/3" />
    </div>
  );
}

/** Skeleton for a list of pack items (Account page). */
export function PackListSkeleton({ count = 3 }: { count?: number }) {
  return (
    <div className="divide-y divide-slate-200" role="status" aria-label="Loading packs">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="p-4 sm:p-6 space-y-3">
          <div className="flex items-center gap-3">
            <Skeleton className="h-5 w-48" />
            <Skeleton className="h-5 w-16 rounded-sm" />
          </div>
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-4 w-24" />
        </div>
      ))}
    </div>
  );
}
